module.exports = __webpack_public_path__ + "img/categorie-coffret-famille-boutrais.f8566028.jpg";